<template>
    <b-row class="mt-1">
        <b-col cols="12">
            <b-row>
                <div class="col-md-6">
                    <h5 class="text-success"> {{ package.package_name }}</h5>
                    <div class="d-flex">
                    <p><strong>Başlangıç Tarihi:</strong> {{ formatDate(package.date) }}</p>
                    <p class="ml-2"><strong>Bitiş Tarihi:</strong> {{ formatDate(package.end_date) }}</p>
                    </div>
                    <p><strong>Tanımlama Tarihi:</strong> {{ formatDate(package.created_date) }}</p>
                    <p><strong>Fiyat:</strong> ₺{{ priceFormat(package.package_price) }}</p>
                </div>
                <div class="col-md-6">
                    <b-badge variant="success" class="mb-2" v-if="package.status">AKTİF</b-badge>
                    <b-badge variant="danger" class="mb-2" v-else>PASİF</b-badge>
                </div>
            </b-row>
        </b-col>
        <b-col cols="12">
            <!-- Limitler Tablosu -->
             
            <b-table-simple responsive class="text-center">
                <b-thead>
                    <b-tr>
                        <b-th>Özellik</b-th>
                        <b-th>Limit</b-th>
                        <b-th>Kullanılan</b-th>
                        <b-th>Kalan</b-th>
                        <b-th style="width: 35%;">Durum</b-th>
                    </b-tr>
                </b-thead>

                <b-tbody>
                    <b-tr v-for="(limit, key) in package.package_limit" :key="key">
                        <b-td>{{ formatFeatureName(key) }}</b-td>
                        <b-td>{{ valueFormat(featuresLabel[key],limit) || 'Sınırsız' }} </b-td>
                        <b-td>
                            <div v-if="keyTypeNumber(key)"> {{ package.package_used[key] || 0 }} </div>
                        </b-td>
                        <b-td>
                            <div v-if="keyTypeNumber(key)">
                                <span v-if="limit">
                                    {{ Math.max(0, limit - (package.package_used[key] || 0)) }}
                                </span>
                                <span v-else class="text-success">Sınırsız</span>
                            </div>
                        </b-td>
                        <b-td>
                          <b-progress v-if="keyTypeNumber(key)" :max="limit">
                                <b-progress-bar 
                                    :value="package.package_used[key]"
                                    :variant="getProgressVariant((package.package_used[key] || 0), limit)">
                                <strong>{{ package.package_used[key] }} / {{ valueFormat(featuresLabel[key],limit) }}</strong>
                                </b-progress-bar>
                            </b-progress>
                            <b-badge v-else variant="success">Aktif</b-badge>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </b-col>
    </b-row>
</template>

<script>
    import { 
        BRow,
          BBadge,BCardTitle, BCol, BCard, BCardHeader, BCardBody, BLink, BButton, BTable, BTableSimple, BThead, BTbody, BTr, BTd, BTh, BProgress,
          BProgressBar} from 'bootstrap-vue';

    export default {
        props: {
            package: {
                type: Object,
                default: {}
            },
            featuresLabel:{
                type:Object,
                default:{}
            }
        },
        
        components: {
            BRow,
            BCol,
            BCard,
            BCardHeader,
            BCardBody,
            BBadge,
            BCardTitle,
            BLink,

            BButton,
            BTable,
            BTableSimple,
            BThead,
            BTbody,
            BTr,
            BTd,
            BTh,
            BProgress,
            BProgressBar
        },
        data() {
            return {
            }
        },
        methods: {
            
            formatFeatureName(key) {
                return this.featuresLabel[key]?.name || key.replace(/_/g, ' ').toUpperCase();
            },

            keyTypeNumber(key) {
                return this.featuresLabel[key]?.type === 'number' || this.featuresLabel[key]?.type === 'day';
            },
            
            getProgressVariant(used, limit) {
                if (!limit) return 'success';
                
                const percentage = (used / limit) * 100;
                if (percentage >= 90) return 'danger';
                if (percentage >= 75) return 'warning';
                if (percentage >= 50) return 'info';
                return 'success';
            },
            isEmpty(value) {
                return value === null || value === undefined || value === '';
            },
            valueFormat(feature,limit) {
                if (feature.type === 'day') {
                    return `${limit} Gün`
                }

                if (feature.type === 'boolean') {
                    return limit ? 'Var' : 'Yok'
                }

                // Sınırsız kontrolü
                if ((feature.id === 6 || feature.id === 12) && this.isEmpty(limit)) {
                    return 'Sınırsız'
                }
                // Sınırsız kontrolü
                if ((feature.id === 1 || feature.id === 17) && this.isEmpty(limit)) {
                    return 'Ücretsiz'
                }

                // Sınırsız kontrolü
                if (feature.id === 14) {
                    if (this.isEmpty(limit)) {
                        return 'Sınırsız'
                    }else{
                        return 'Son ' + limit + ' Yıl'
                    }
                }

                return limit
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>